/**
 * @Date:   2021-01-22 06:13:27
 * @Filename: data.js
 * @Last modified time: 2021-01-24 04:53:21
 */
export default function () {
  return {};
}